import { Stack, Typography } from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs, { Dayjs } from 'dayjs';
import React, { useCallback, useState } from 'react';

import { ProjectWithLastScanned } from '../../../Types/dealGPT';

interface ProjectActiveDatesProps {
  project: ProjectWithLastScanned;
  onStartDateChange?: (date: Date | undefined) => void;
  onEndDateChange?: (date: Date | undefined) => void;
  width?: number | string;
}

const ProjectActiveDates = ({
  project,
  onStartDateChange,
  onEndDateChange,
  width = 150,
}: ProjectActiveDatesProps) => {
  const [localStart, setLocalStart] = useState<Dayjs | null>(
    project.activeStartDate ? dayjs(project.activeStartDate) : null
  );
  const [localEnd, setLocalEnd] = useState<Dayjs | null>(
    project.activeEndDate ? dayjs(project.activeEndDate) : null
  );

  const handleStartChange = useCallback(
    (date: Dayjs | null) => {
      onStartDateChange?.(date?.toDate());
      setLocalStart(date);
    },
    [onStartDateChange]
  );

  const handleEndChange = useCallback(
    (date: Dayjs | null) => {
      onEndDateChange?.(date?.toDate());
      setLocalEnd(date);
    },
    [onEndDateChange]
  );

  return (
    <Stack direction="row" spacing={2} alignItems="center">
      <DatePicker
        label="Start Date"
        value={localStart}
        onChange={handleStartChange}
        maxDate={localEnd ?? undefined}
        slotProps={{ textField: { size: 'small', sx: { width } } }}
      />
      <Typography variant="h4">-</Typography>
      <DatePicker
        label="End Date"
        value={localEnd}
        onChange={handleEndChange}
        minDate={localStart ?? undefined}
        slotProps={{ textField: { size: 'small', sx: { width } } }}
      />
    </Stack>
  );
};

export default ProjectActiveDates;
